import { createStore } from 'vuex'
import _filter from 'lodash/filter'
import _find from 'lodash/find'

const store = createStore( {
    state: {
        projects: [],
        regions: [],
        actionFields: [],
        regionFilterset: [],
        actionFieldFilterset: [],
        mainSetup: {},
        geoData: null
    },
    getters: {
        actionFieldData: ( state ) => state.actionFields,
        regionsData: ( state ) => state.regions,
        projectsData: ( state ) => state.projects,
        geoData: ( state ) => state.geoData,
        actionFieldFilter: ( state ) => state.actionFieldFilterset,
        regionFilter: ( state ) => state.regionFilterset,
        actionFieldByName: ( state ) => ( name ) => _find( state.actionFields, { name: name } ),
        actionFieldById: ( state ) => ( id ) => _find( state.actionFields, { id: id } ),
        regionById: ( state ) => ( id ) => _find( state.regions, { id: id } ),
        projectsByRegion: ( state ) => ( id ) => _filter( state.projects, ( project => project.regions.includes( id ) ) ),
        mainSetup: ( state ) => state.mainSetup
    },
    mutations: {
        setData( state, data ) {
            state.projects = data.projects
            state.regions = data.regions
            state.actionFields = data.action_fields
            state.mainSetup = data.main_setup
        },
        setGeoData( state, data ) {
            state.geoData = data
        },
        setRegionsFilter( state, regionID ) {
            if ( state.regionFilterset.includes( regionID ) ) {
                state.regionFilterset.splice( state.regionFilterset.indexOf( regionID ), 1 )
            } else {
                state.regionFilterset.push( regionID )
            }
        },
        setActionFieldFilter( state, actionFields ) {
            state.actionFieldFilterset = actionFields
        },
    },
    actions: {
        async fetchProjectsData( { commit } ) {
            const projectDataResponse = await fetch( '/wp-json/wbk-projects/v1/projects' )
            const projectData = await projectDataResponse.json()

            commit( 'setData', projectData )
        },
        async fetchGeoData( { commit } ) {
            const geoDataResponse = await fetch( '/wp-content/plugins/wbk-projects-tool/data/landkreise-emm.geojson' )
            const geoData = await geoDataResponse.json()

            commit( 'setGeoData', geoData )
        },
        updateRegionsFilter( { commit }, value ) {
            if ( value !== 'null' ) {
                commit( 'setRegionsFilter', value )
            }
        }
    }
} )

export default store